import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const ns = 'shared';
export const keyPrefix = 'side_nav_layout';
export const useSideNavLayoutTranslation = (): UseTranslationResponse<
  typeof ns,
  typeof keyPrefix
> => useTranslation(ns, { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    section_error: 'В разделе есть ошибки',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    section_error: 'The section has errors',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    section_error: 'La sección tiene errores',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    section_error: 'A seção tem erros',
  },
}) : {}) as Record<string, unknown>;
